import {useEffect, useState} from 'react'
import {
	RefundableProvider,
	useRefundableActions
} from 'protect-group-pulse-react'
import {options, sessionKeys} from '../data'
import FormInput from '../components/ui/FormInput'
import Button from '../components/ui/Button'

function CancelSaleDev() {
	const [saleId, setSaleId] = useState<string>('')
	const {cancelSale} = useRefundableActions()

	useEffect(() => {
		setSaleId(sessionStorage.getItem(sessionKeys.bookingReference) ?? '')
	}, [])

	const handleClick = async () => {
		try {
			const response = await cancelSale(saleId)
			console.log('Cancel Sale Response', response)
		} catch (err) {
			console.error('Cancel failed', err)
		}
	}

	return (
		<div className="flex flex-col">
			<div>
				<FormInput
					id="bookingRefereence"
					label="Booking Reference"
					onChange={(evt) => setSaleId(evt.target.value)}
					value={saleId}
				/>
			</div>
			<div>
				<Button
					label="Cancel Sale"
					onClick={handleClick}
				/>
			</div>
			<div></div>
		</div>
	)
}

export default function CancelSale() {
	return (
		<div className="flex flex-col h-screen w-full">
			<h2 className="mb-3 pb-3 pt-4 border-b-2 border-sky-500 text-lg text-center">Cancel Sale</h2>
			<div className="p-4">
				<RefundableProvider options={options}>
					<CancelSaleDev/>
				</RefundableProvider>
			</div>
		</div>
	)
}
